import React, { useState } from "react";
import { MyFilteredMattersContainer } from "../../../../src/containers/my-filtered-matters-container";
import { MatterStatus } from "@graphql-types";
import TabPane from "antd/lib/tabs/TabPane";
import { Tabs, Radio } from "antd";
import { Permission, useCurrentUserData } from "~/hooks";
import styles from "./active-matters.module.css";
import { LiveMatterOrderBy } from "../active-matters-status-filter-list";

const {
  ["order-by-container"]: orderByContainerClassName,
  ["order-by-radio-group"]: orderByRadioGroupClassName,
  ["radio-button-left"]: radioButtonLeftClassName,
  ["radio-button-right"]: radioButtonRightClassName,
  ["live-matters-container"]: liveMattersContainerClassName,
  ["tab-content"]: tabContentClassName,
} = styles;

type Pathname = string;
type Search = string;
type Hash = string;
interface Path {
  pathname: Pathname;
  search: Search;
  hash: Hash;
}
type PartialPath = Partial<Path>;
type To = string | PartialPath;
type State = object | null;
interface LinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  replace?: boolean;
  state?: State;
  to: To;
}

export type HTMLLink = React.ForwardRefExoticComponent<
  LinkProps & React.RefAttributes<HTMLAnchorElement>
>;

export const ActiveMatters = () => {
  const currentUserData = useCurrentUserData({ cache: false });
  const [orderBy, setOrderBy] = useState<LiveMatterOrderBy>(LiveMatterOrderBy.RiskLevel);

  const userOrganisationalUnitId = currentUserData.currentUser?.organisationalUnitId;
  const showOrgUnitTab =
    currentUserData.permissions?.includes(Permission.TIMEKEEPER_MANAGER) &&
    userOrganisationalUnitId;

  const orderByControls = (
    <div className={orderByContainerClassName}>
      Order by:
      <Radio.Group
        value={orderBy}
        onChange={(e) => setOrderBy(e.target.value)}
        className={orderByRadioGroupClassName}
      >
        <Radio.Button value="riskLevel" className={radioButtonLeftClassName}>
          Risk Level
        </Radio.Button>
        <Radio.Button value="recentlyAdded">Recently Added</Radio.Button>
        <Radio.Button value="recentWork" className={radioButtonRightClassName}>
          Recent Work
        </Radio.Button>
      </Radio.Group>
    </div>
  );

  return (
    <div className={liveMattersContainerClassName}>
      <Tabs defaultActiveKey="1" type="card" tabBarExtraContent={{ right: orderByControls }}>
        <TabPane className={tabContentClassName} key={"1"} tab="My Matters">
          <MyFilteredMattersContainer
            filterBy="user"
            status={MatterStatus.Live}
            orderBy={orderBy}
          />
        </TabPane>
        {showOrgUnitTab && (
          <TabPane className={tabContentClassName} key={"2"} tab="My Practice Area">
            <MyFilteredMattersContainer
              organisationalUnitId={userOrganisationalUnitId}
              filterBy="organisationalUnit"
              status={MatterStatus.Draft}
              orderBy={orderBy}
            />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};
